module.exports = __webpack_public_path__ + "static/cover-47542d634fd8e13779e57d968d17204e.jpg";